/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardDailyXpBody
 */
export interface RewardDailyXpBody {
    /**
     * The Discord member ID to reward daily XP
     * @type {string}
     * @memberof RewardDailyXpBody
     */
    discordMemberId: string;
}

/**
 * Check if a given object implements the RewardDailyXpBody interface.
 */
export function instanceOfRewardDailyXpBody(value: object): value is RewardDailyXpBody {
    if (!('discordMemberId' in value) || value['discordMemberId'] === undefined) return false;
    return true;
}

export function RewardDailyXpBodyFromJSON(json: any): RewardDailyXpBody {
    return RewardDailyXpBodyFromJSONTyped(json, false);
}

export function RewardDailyXpBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardDailyXpBody {
    if (json == null) {
        return json;
    }
    return {
        
        'discordMemberId': json['discordMemberId'],
    };
}

export function RewardDailyXpBodyToJSON(json: any): RewardDailyXpBody {
    return RewardDailyXpBodyToJSONTyped(json, false);
}

export function RewardDailyXpBodyToJSONTyped(value?: RewardDailyXpBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discordMemberId': value['discordMemberId'],
    };
}

